<template>
	<div
		class="filter-badge"
		:class="{'clear': type === 'clearAll'}"
		@click="type === 'clearAll' && clearFilters($event)"
	>
		<span>{{ badge.label }}</span>
		<button
			v-if="type === 'badge'"
			class="filter-badge-remove"
			@click="removeFilter(badge.id)"
		>
			<Icon
				icon-name="e-remove"
				size="xs"
			/>
		</button>
	</div>
</template>

<script>
import Icon from '@components/Icon';

export default {
	name:       'FilterBadge',
	components: { Icon },
	props:      {
		badge: {
			type:    Object,
			default: () => {},
		},
		type: {
			type:      String,
			default:   'badge',
			validator: (value) => ['badge', 'clearAll'].includes(value),
		},
	},
	methods: {
		removeFilter(id) {
			this.$emit('remove-filter', id);
		},
		clearFilters(evt) {
			this.$emit('clear-filters', evt);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.filter-badge {
	@include text-sm-2;
	background: var(--color-hype-yellow);
	color: var(--color-text-on-hype-yellow);
	padding: 2px 6.5px 2px 8px;
	display: inline-flex;
	align-items: center;
	margin-right: 8px;
	margin-bottom: 10px;
	border-radius: 12px;

	&:hover {
		background: var(--color-hype-yellow--active);
	}

	button {
		margin-left: 10px;
	}

	&.clear {
		color: var(--color-soft-white);
		padding: 0;
		background: transparent;
		text-decoration: underline;
		cursor: pointer;
	}

	::v-deep {
		svg {
			margin-bottom: 2px;
		}
	}
}
</style>
